/**
 * ****************************************************************************
 * @description     :   Reducer to receive action and change state for all app
 * @created at      :   2020/12/03
 * @created by      :   QuyPN - quy.pham@toploop.co
 * @package         :   dashlite-admin-react
 * @copyright       :   Copyright (c) TOPLOOP
 * @version         :   1.0.0
 * ****************************************************************************
 */

import Actions from "./action";

/**
 * Initial state of app
 */
const initialState = {
    loadMenu: false,
    menus: [],
    functions: [],
}

/**
 * Reducer to process change data of app
 * -----------------------------------------
 * @author : QuyPN - 2023/07/18 - create
 * @param  : {Object} state - Current sate of app
 * @param  : {Object} action - information of action will process
 * @access : public
 */
export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.GET_MENU_RESPONSE:
            return {
                ...state,
                menus: action.payload,
                loadMenu: true
            }
        case Actions.HIDE_LOADING:
            return {
                ...state,
            }
        case Actions.SHOW_LOADING:
            return {
                ...state,
            }
        case Actions.HIDE_LOADING_MENU:
            return {
                ...state,
                loadMenu: true
            }
        case Actions.GET_FUNCTION_RESPONSE:
            return {
                ...state,
                functions: action.payload,
            }
        case Actions.SET_FORM_FIELD_MASTER_DATA:
            return {
                ...state,
                [action.field]: action.payload
            }
        default:
            return state;
    }
}
